import {
  bulletTwoSubtitleText,
  bulletTwoTitleText,
  returnMessages,
} from "@redotech/redo-marketing-core-common/text-defaults/info-modal-default-text";
import { Coverage } from "@redotech/redo-return-coverage-common/coverage";
import { InfoModal } from "@redotech/redo-storefront-common/info-modal";

export interface InfoModalBullet {
  titleText: string;
  subtitleText: string;
}

// Visibility follows shopper eligibility only; custom copy overrides the text
// but must never advertise a coverage the shopper can't actually get.
export function getReturnsBullet({
  returnsCoverageEnabled,
  returnsCoverage,
  finalSaleReturnsCoverageEnabled,
  modalCustomizationsV2,
}: {
  returnsCoverageEnabled: boolean;
  returnsCoverage?: Coverage;
  finalSaleReturnsCoverageEnabled: boolean;
  modalCustomizationsV2?: InfoModal;
}): InfoModalBullet | undefined {
  if (!returnsCoverageEnabled) {
    return undefined;
  }

  let key =
    `${returnsCoverage?.exchange ? 1 : 0}${returnsCoverage?.refund ? 1 : 0}${returnsCoverage?.storeCredit ? 1 : 0}` as `${0 | 1}${0 | 1}${0 | 1}`;

  if (finalSaleReturnsCoverageEnabled && key === "000") {
    key = "111";
  }

  const { primaryMessage, secondaryMessage } = returnMessages[key] || {
    primaryMessage: "Free returns & exchanges",
    secondaryMessage: "Return or exchange",
  };

  return {
    titleText: modalCustomizationsV2?.line1?.titleText || primaryMessage,
    subtitleText:
      modalCustomizationsV2?.line1?.subtitleText || secondaryMessage,
  };
}

export function getPackageProtectionBullet({
  packageProtectionEnabled,
  modalCustomizationsV2,
}: {
  packageProtectionEnabled?: boolean;
  modalCustomizationsV2?: InfoModal;
}): InfoModalBullet | undefined {
  if (!packageProtectionEnabled) {
    return undefined;
  }

  return {
    titleText: modalCustomizationsV2?.line2?.titleText || bulletTwoTitleText,
    subtitleText:
      modalCustomizationsV2?.line2?.subtitleText || bulletTwoSubtitleText,
  };
}
